import React from 'react';
import { Text } from '@ui';
import { ShowOnReportCell } from '../components/ShowOnReportCell';
/** `dataKey`s these columns sort on, handed to the surface as `entitySortableColumns`. */
export const WORK_ORDER_SORTABLE_COLUMNS = ['sourceLabel', 'showOnReport'];
/**
 * Work Order's own two columns — Source and Show on report — inserted by the shared surface
 * between Name and Type.
 *
 * Source exists because this table unions four kinds of document and the user otherwise has no way
 * to tell an uploaded file from a generated report that merely looks like one. It is also what
 * makes the differing row behaviour legible: why one row has a checkbox and another an em dash,
 * why one can be selected and another cannot.
 */
export function buildWorkOrderColumns({ translateFn, workOrderId }) {
    return [
        {
            dataKey: 'sourceLabel',
            label: translateFn('columns.source'),
            width: '150px',
            renderer: ({ item }) => React.createElement(Text, { variant: "body" }, item.sourceLabel)
        },
        {
            dataKey: 'showOnReport',
            label: translateFn('columns.show_on_report'),
            width: '130px',
            align: 'center',
            renderer: ({ item }) => (React.createElement(ShowOnReportCell, { item: item, workOrderId: workOrderId, translateFn: translateFn }))
        }
    ];
}
